import { Cookie } from '@vue-util/cookie';
import {
  MISCGCS,
  RTD_COOKIE_NAME,
  STATE_COOKIE_NAME,
  SHIPPING_COUNTRY_COOKIE_NAME,
  ZIP_CODE_COOKIE_NAME,
  CUSTOMER_ID_COOKIE_NAME_MCOM,
  CUSTOMER_ID_COOKIE_NAME_BCOM,
  SIGNED_IN_COOKIE_NAME,
  ADOBE_COOKIE_NAME,
} from './constants';

export const USER_STATUS = {
  SIGNED_IN: 'signedIn',
  NOT_SIGNED_IN: 'notSignedIn',
};

export const userInfo = {
  isSignedIn() {
    return !!Number(Cookie.get(SIGNED_IN_COOKIE_NAME));
  },
  zipCode() {
    return Cookie.get(ZIP_CODE_COOKIE_NAME, MISCGCS);
  },
  stateCode() {
    return Cookie.get(STATE_COOKIE_NAME, MISCGCS);
  },
  countryCode() {
    return Cookie.get(SHIPPING_COUNTRY_COOKIE_NAME);
  },
  customerId(brand) {
    return brand === 'mcom' ? Cookie.get(CUSTOMER_ID_COOKIE_NAME_MCOM) : Cookie.get(CUSTOMER_ID_COOKIE_NAME_BCOM);
  },
  validVisitorId(visitorId) {
    return visitorId && visitorId.length < 100;
  },
  adobeVisitorId() {
    const adobeCookie = Cookie.get(ADOBE_COOKIE_NAME)?.trim() || '';
    const unparsedCookieArray = adobeCookie.split('|');
    const mcmidIndex = unparsedCookieArray.indexOf('MCMID');
    return mcmidIndex !== -1 ? unparsedCookieArray[mcmidIndex + 1] : '';
  },
  guid() {
    const S4 = () => {
      const d = new Date();
      return ((d.getTime() + Math.random()) * 0x10000 || 0).toString(16).substring(1);
    };

    return S4() + S4() + S4() + S4();
  },
  visitorId() {
    const rtdCookie = Cookie.get(RTD_COOKIE_NAME)?.trim() || '';

    // if session hasn't been started or the user has an invalid visitor Id
    if (!this.validVisitorId(rtdCookie)) {
      const visitorId = this.guid();
      const d = new Date();
      d.setFullYear(d.getFullYear() + 30);

      // push Expiration Date of Cookie
      Cookie.set(RTD_COOKIE_NAME, visitorId, null, { expires: d.toUTCString() });
      return visitorId;
    }

    return rtdCookie;
  },
  getUserStatus() {
    return this.isSignedIn() ? USER_STATUS.SIGNED_IN : USER_STATUS.NOT_SIGNED_IN;
  },
};
